const RoleAndPermissionStyles = {
  cardGrid: {
    mb: 3,
  },
  roleCard: (isSelected: boolean) => ({
    p: 2.5,
    borderRadius: 3,
    border: isSelected ? "2px solid #23272E" : "1.5px solid #e6e8ec",
    boxShadow: "none",
    cursor: "pointer",
    minHeight: 90,
    transition: "border 0.2s",
    mb: 1,
  }),
  roleName: {
    fontWeight: 600,
    mb: 1,
  },
  assignedUsersText: {
    color: "#7C8493",
  },
  headerBox: {
    display: "flex",
    flexDirection: { xs: "column", sm: "row" },
    alignItems: { xs: "stretch", sm: "center" },
    justifyContent: "space-between",
    mb: 2,
    gap: 2,
  },
  usersTitle: {
    fontWeight: "bold",
  },
  searchField: {
    width: { xs: "100%", sm: 300 },
  },

  auditLogSearchRow: {
    display: "flex",
    flexDirection: { xs: "column", sm: "row" },
    gap: 2,
    mb: 2,
  },
  auditLogSearchField: {
    width: { xs: "100%", sm: 500 },
    background: "#F9FAFB",
    borderRadius: 2,
  },
  auditLogInputProps: {
    borderRadius: 2,
    background: "#F9FAFB",
  },
  auditLogDropdownBox: {
    position: "relative",
    width: 240,
  },
  auditLogSelect: {
    width: 240,
    background: "#F9FAFB",
    borderRadius: 2,
    ".MuiSelect-select": { py: 1.2 },
  },
  auditLogMenuPaper: {
    width: 240,
    mt: 1,
  },

  createRoleDialogBox: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
    mt: 1,
  },
  createRolePermissionsBox: {
    border: "1px solid #e0e0e0",
    borderRadius: 2,
    p: 2,
    maxHeight: 220,
    overflowY: "auto",
    background: "#fafbfc",
  },
  createRolePermissionGroup: {
    mb: 1,
  },
  createRolePermissionGroupTitle: {
    fontWeight: "bold",
    mb: 0.5,
  },
  createRolePermissionDivider: {
    my: 1,
  },
  createRoleSearchField: {
    mb: 1,
  },

  // Summary cards grid
  summaryGrid: {
    mb: 3,
  },
  summaryCard: {
    p: 3,
    borderRadius: 3,
    boxShadow: "0 2px 8px 0 rgba(16,30,54,.06)",
    border: "1.5px solid #e6e8ec",
    minHeight: 170,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    transition: "box-shadow 0.2s",
    "&:hover": {
      boxShadow: "0 4px 16px 0 rgba(16,30,54,.12)",
    },
  },
  summaryCardHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    mb: 1,
  },
  summaryCardLabel: {
    color: "#5A5D6A",
    fontWeight: 600,
  },
  summaryCardValue: {
    fontWeight: 700,
    color: "#15192C",
    fontSize: { xs: 28, md: 32 },
    lineHeight: 1.1,
  },
  summaryCardSub: {
    color: "#7C8493",
    mt: 0.5,
    fontSize: 15,
  },

  // Header
  pageHeader: {
    display: "flex",
    flexDirection: { xs: "column", sm: "row" },
    justifyContent: "space-between",
    alignItems: { xs: "flex-start", sm: "center" },
    mb: 3,
    gap: 2,
  },
  pageTitle: (theme: any) => ({
    background: (theme: any) =>
      `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    fontWeight: "bold",
  }),
  createRoleButton: {
    width: { xs: "100%", sm: "auto" },
    borderRadius: "4px",
  },

  // Tabs
  tabsPaper: {
    mb: 3,
  },

  // Table search
  tableSearch: {
    mb: 2,
    width: { xs: "100%", sm: 300 },
  },

  // Mobile card
  mobileRoleCard: {
    mb: 2,
    p: 2,
    display: "flex",
    flexDirection: "column",
    gap: 1,
  },
  mobileRoleCardHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  mobileRoleCardDescription: {
    color: "text.secondary",
  },
  mobileRoleCardInfo: {
    display: "flex",
    gap: 2,
    flexWrap: "wrap",
  },
  mobileRoleCardActions: {},

  // No role found
  noRoleFoundPaper: {
    p: 3,
    textAlign: "center",
  },

  // Delete dialog
  deleteDialogTitle: {
    // default MUI
  },
  deleteDialogContent: {
    // default MUI
  },
  deleteDialogActions: {
    // default MUI
  },

  // Permissions styles
  permissionsCardGrid: {
    mb: 3,
  },
  permissionsRoleCard: (isSelected: boolean) => ({
    p: 2.5,
    borderRadius: 3,
    border: isSelected ? "2px solid #23272E" : "1.5px solid #e6e8ec",
    boxShadow: "none",
    cursor: "pointer",
    minHeight: 90,
    transition: "border 0.2s",
    mb: 1,
  }),
  permissionsRoleName: {
    fontWeight: 600,
    mb: 1,
  },
  permissionsRoleInfo: {
    display: "flex",
    gap: 3,
    color: "#7C8493",
  },
  permissionsHeaderBox: {
    display: "flex",
    flexDirection: { xs: "column", sm: "row" },
    alignItems: { xs: "stretch", sm: "center" },
    justifyContent: "space-between",
    mb: 2,
    gap: 2,
  },
  permissionsTitle: {
    fontWeight: "bold",
  },
  permissionsSearchField: {
    width: { xs: "100%", sm: 300 },
  },
};

export default RoleAndPermissionStyles;
